



































































































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
//  @modules
import { getModule } from "vuex-module-decorators";
import UserModule from "@/store/clients/User.module";
const User = getModule(UserModule, store);

@Component({})
export default class Settings extends Vue {
  get isAdmin(): boolean {
    return User.isAdmin;
  }

  get isSuperOrAdmin(): boolean {
    return User.isSuperOrAdmin;
  }
}
